import { PropsWithChildren } from 'react';

import {
  CmsTileGridContentRight,
  CmsTileModalHeading,
  CmsTileModalSubheading,
} from './CmsTileModalRightContent.styled';

type Props = {
  heading: string;
  subHeading?: string;
};

export function CmsTileModalRightContent({
  heading,
  subHeading,
  children,
}: PropsWithChildren<Props>) {
  return (
    <CmsTileGridContentRight>
      <CmsTileModalHeading>{heading}</CmsTileModalHeading>

      {subHeading && (
        <CmsTileModalSubheading>{subHeading}</CmsTileModalSubheading>
      )}

      {children}
    </CmsTileGridContentRight>
  );
}
